import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Util } from '@libs/utilities/util';
import { Subject } from 'rxjs';

import { IAddonSuccessData, IAddonPassthrough, TypeAddonWindowPaddle, IAddonPaddleCheckoutParams, IAddonPaddleAuthParams } from './paddle.interface';


@Injectable()
export class AddonPaddleService {

	//** Window object to access the script functions */
	private readonly window	 : TypeAddonWindowPaddle;
	private readonly callback: Subject<IAddonSuccessData> = new Subject<IAddonSuccessData>();

	//** Helper Variables */
	private ref: string | null = null;
	private id : string | null = null;

	constructor(
		@Inject(DOCUMENT)
		private document: Document
	) {
		this.window = this.document.defaultView as TypeAddonWindowPaddle;
	}

	openCheckout(paddleParams: IAddonPaddleCheckoutParams): void {
		this.window.Paddle.Checkout.open(paddleParams);
	}

	setRef(ref: string): void {
		this.ref = ref;
	}

	getCallback(): Subject<IAddonSuccessData> {
		return this.callback;
	}

	checkout(authParams: IAddonPaddleAuthParams, paddlePlanId: string, coupon: string | null = null): void {
		this.id = Util.Random.randomKey(32);
		if (!authParams) throw new Error(`AddonPaddleService => checkout => FATAL ERROR : Auth Params are not defined.`);
		this.openCheckout(this.getPaddleObject(authParams, paddlePlanId, coupon));
	}

	successCallback = (data: IAddonSuccessData): void => {

		//0 - purchase unsuccessful
		if (Util.Object.isEmpty(data)) throw new Error(`AddonPaddleService => successCallback => FATAL ERROR: Purchase unsuccessful: ${data}`);

		//1 - purchase success
		if (data.checkout.completed) this.callback.next(data);
	};

	closeCallback = (data: IAddonSuccessData): void => {

		//0 - purchase not done
		if (Util.Object.isEmpty(data)) return;

		//1 - if purchase done
		if (data.checkout.completed) this.callback.next(data);
	};


	/**------------------------------------------------------
	 * Helper Function
	 */
	private getPaddleObject(authParams: IAddonPaddleAuthParams, paddlePlanId: string, coupon: string | null): IAddonPaddleCheckoutParams {
		const paddleObject : IAddonPaddleCheckoutParams = {
			product		   : paddlePlanId,
			passthrough	   : Util.Basic.stringifyObject(this.getPassthrough(authParams, paddlePlanId, coupon)),
			email		   : authParams.userEmail,
			coupon		   : coupon,
			successCallback: this.successCallback,
			closeCallback  : this.closeCallback
		};
		return paddleObject;
	}

	private getPassthrough(authParams: IAddonPaddleAuthParams, paddlePlanId: string, coupon: string | null): IAddonPassthrough {
		const passthroughData: IAddonPassthrough = {
			isLoggedIn  : Util.Boolean.toBoolean(authParams.isAuthenticated),
			identifier  : this.id,
			userId	    : authParams.userId,
			ref_code    : this.ref,
			coupon	    : coupon,
			paddlePlanId: paddlePlanId
		};
		return passthroughData;
	}
}
